$(document).ready(function() {

  // Handle Photo Banner sizing
  initializeSizing();
  //blackBarResize();
  setTimeout(function(){  //window.resizeBy(-100, 0);
    initializeSizingSecond();
  }, 4000);

  // Ajax Forms
  $(".ajaxForm").submit(function(){

    console.log($(this).serialize());
    alert($(this).attr("action"));
    $.post($(this).attr("action"),$(this).serialize(), function( data ) {
      console.log(data);
      // console.log(data);
      if (data.result == "true"){

        $(".form-content").hide();
        $(".form-success").removeClass("d-none");

      }else{
        console.log("An error occurred while processing the form");

      }

    },'json');

    //e.preventDefault();
    return false;

  });

    // Ajax submit of invisible recaptcha form
    // _submitEvent = function() {
    //     $.ajax({
    //         type: "POST",
    //         url: "/contact",
    //          data: {
    //             "_token": $('input[name=_token]').val(),
    //             "first_name": $("#first_name").val(),
    //             "last_name": $("#last_name").val(),
    //             "email": $("#email").val(),
    //             "phone": $("#phone").val(),
    //             "comments": $("#comments").val(),
    //             // important! don't forget to send `g-recaptcha-response`
    //             "g-recaptcha-response": $("#g-recaptcha-response").val()
    //         },
    //         dataType: "json",
    //         success: function(data) {
    //             // success logic
    //             //alert('good');
    //             //console.log('good');
    //
    //             $(".form-content").hide();
    //             $(".form-success").removeClass("d-none");
    //
    //         },
    //         error: function(data) {
    //             // error logic
    //             //alert('bad');
    //             console.log("An error occurred while processing the form");
    //
    //         }
    //     });
    // };

    $(".col-12").find("img").each(function(index){

      if ($(this).hasClass("img-fluid")){
        // Good
      }else{
        $(this).addClass("img-fluid");
      }

    });


});

function initializeSizing(){

  photoBarSizing();

}
function initializeSizingSecond(){

  initializeSizing();

}
function windowResized(){

  photoBarSizing();

}

function photoBarSizing(){

  $(".photoBar").each(function() {

    // Pre-find the image since we use it a lot
    var theBannerImage = $(this).children(".photoBar-image").find("img");

    var contentHeight = $(this).find(".photoBar-content").height();
    var contentWidth = $(this).width();

    var preliminaryImageHeight =  theBannerImage.height();
    var preliminaryImageWidth =  theBannerImage.width();

    // Force the image container height to match content
     $(this).children(".photoBar-image").css("height",contentHeight);

    // Adjust image dimensions if needed
    if (preliminaryImageHeight < contentHeight){

      // Recalculate image dimensions to fill height (overflow is hidden)
      var newImageWidth = (preliminaryImageWidth/preliminaryImageHeight)*contentHeight;
      theBannerImage.height(contentHeight);
      theBannerImage.width(newImageWidth);

    }else{

      theBannerImage.height('auto');
      theBannerImage.width(contentWidth);

    }

    $(this).children('.background-blue-overlay').height($(this).height());
    $(this).children('.background-grey-overlay').height($(this).height());

  });

}



// WEBPACK FOOTER //
// ./resources/assets/js/public/global.js